module.exports = {
  title: `Greenhead Blog`,
  description: `Blog posted about ...`,
  author: `Greenhead`,
  introduction: `프론트엔드 개발자 윤녹두입니다 :)`,
  siteUrl: `https://greenhead.blog`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `shren207`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: ``, // Your LinkedIn account
    instagram: ``, // Your Instagram account
  },
  icon: `content/assets/felog.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: ``, // Your disqus-short-name. check disqus.com.
    utterances: 'shren207/greenhead-blog', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: ``,
  },
  share: {
    facebookAppId: ``, // Add facebookAppId for using facebook share feature v3.2
  },
  ga: '0', // Add your google analytics tranking ID
  ad: '', // Add your google adsense publisherId `ca-pub-xxxxxxxxxx`
};
